import { render, staticRenderFns } from "./NbQuoteReceiverInformations.vue?vue&type=template&id=43b3f3e8&"
import script from "./NbQuoteReceiverInformations.vue?vue&type=script&lang=js&"
export * from "./NbQuoteReceiverInformations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports